import { parseISO, format } from 'date-fns';

String.prototype.toFormattedDateOrDefault = function (this: string, dateFormat: string = "dd.MM.yyyy"): string {
  if (!this.trim()) {
    return '';
  }

  try {
    const date = parseISO(this);
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date');
    }
    return format(date, dateFormat);
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid date';
  }
};

String.prototype.convertToValidUrl = function (): string {
  const urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;

  let newUrl = decodeURIComponent(this.toString()).trim().replace(/\s/g, "");

  if (!urlPattern.test(newUrl)) {
    return "";
  }

  if (/^(:\/\/)/.test(newUrl)) {
    newUrl = `http${newUrl}`;
  }

  if (!/^(http|https):\/\//i.test(newUrl)) {
    newUrl = `https://${newUrl}`;
  }

  return newUrl.replace(/^http:\/\//i, "https://");
};

String.prototype.prependBaseUrl = function (): string {
  const baseUrl = process.env.REACT_APP_BASE_URL || '';
  return baseUrl + this.toString();
};

String.prototype.pointToSetup  = function (): string {
  return this.toString() + "&IsSetup=true";
};